var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex mb-3"},[_vm._t("contents")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }